import { buildAttachmentInfoParts } from "@/lib/utils/buildAttachmentInfoParts";
import { memo } from "react";

interface QuestionnaireAttachmentInfoProps {
  confirmed_at?: string | null;
  size?: string | null;
  filePath: string;
}

export const QuestionnaireAttachmentInfo = memo(
  function QuestionnaireAttachmentInfo({
    confirmed_at,
    size,
    filePath,
  }: QuestionnaireAttachmentInfoProps) {
    const infoParts = buildAttachmentInfoParts({
      confirmed_at,
      size,
      filePath,
    });

    if (infoParts.length === 0) {
      return null;
    }

    return (
      <span className="text-xs text-slate-600 whitespace-nowrap">
        {infoParts.join(" | ")}
      </span>
    );
  },
);
